module.exports = __webpack_public_path__ + "img/bigwin-text.fc6779d8.png";